/** Общее для вкладок настроек: типы ответа API и оболочка секции. */

import type { ReactNode } from 'react';
import type { CommunitySettings, WiringSettings } from '@ak/shared';

import { Panel } from '../../components/ui.tsx';

export interface SettingsResponse {
  settings: CommunitySettings;
  defaults: CommunitySettings;
  wiring: {
    overrides: WiringSettings;
    effective: { channels: Record<string, string | null>; roles: Record<string, unknown> };
    fromEnvironment: { channels: Record<string, string | null>; roles: Record<string, unknown> };
  };
}

export interface GuildStructure {
  available: boolean;
  reason?: string;
  channels: { id: string; name: string; type: string; parentId: string | null; parentName: string | null }[];
  roles: { id: string; name: string; color: string }[];
}

/** Изменение одного поля черновика. Черновик общий на всю страницу. */
export type UpdateSetting = <K extends keyof CommunitySettings>(key: K, value: CommunitySettings[K]) => void;

export interface SettingsTabProps {
  draft: CommunitySettings;
  update: UpdateSetting;
}

export function Section({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: ReactNode;
}): ReactNode {
  return (
    <Panel className="mb-4">
      <div className="border-b px-5 py-4" style={{ borderColor: 'var(--border-subtle)' }}>
        <h2 className="font-semibold">{title}</h2>
        {description !== undefined && (
          <p className="mt-0.5 text-sm" style={{ color: 'var(--text-muted)' }}>
            {description}
          </p>
        )}
      </div>
      <div className="space-y-4 px-5 py-5">{children}</div>
    </Panel>
  );
}
